/**
 * Track lists for each game title in Whapaxx Championships.
 * Used for dropdown selections when creating rounds/classes.
 */

export const F1_TRACKS = [
  'Albert Park (Australia)',
  'Shanghai International Circuit (China)',
  'Suzuka (Japan)',
  'Bahrain International Circuit (Bahrain)',
  'Jeddah Corniche Circuit (Saudi Arabia)',
  'Miami International Autodrome (USA)',
  'Imola – Autodromo Enzo e Dino Ferrari (Italy)',
  'Monaco (Monte Carlo)',
  'Circuit de Barcelona-Catalunya (Spain)',
  'Circuit Gilles Villeneuve (Canada)',
  'Red Bull Ring (Austria)',
  'Silverstone (UK)',
  'Spa-Francorchamps (Belgium)',
  'Hungaroring (Hungary)',
  'Zandvoort (Netherlands)',
  'Monza (Italy)',
  'Baku City Circuit (Azerbaijan)',
  'Singapore (Marina Bay)',
  'Circuit of the Americas (USA)',
  'Autódromo Hermanos Rodríguez (Mexico)',
  'Interlagos (Brazil)',
  'Las Vegas Strip Circuit',
  'Lusail Circuit (Qatar)',
  'Yas Marina (Abu Dhabi)',
  'Silverstone (Reverse)',
  'Red Bull Ring (Reverse)',
  'Zandvoort (Reverse)',
];

export const GT7_TRACKS = [
  // Real-World — Americas
  'Daytona International Speedway',
  'WeatherTech Raceway Laguna Seca',
  'Willow Springs (Big Willow)',
  'Willow Springs (Streets)',
  'Willow Springs (Horse Thief Mile)',
  'Colorado Springs (Dirt)',
  "Fisherman's Ranch (Dirt)",
  'Watkins Glen',
  'Road Atlanta',
  // Real-World — Europe
  'Nürburgring (Nordschleife)',
  'Nürburgring (GP)',
  'Circuit de Spa-Francorchamps',
  'Autodromo Nazionale Monza',
  'Brands Hatch',
  'Red Bull Ring',
  'Circuit de Barcelona-Catalunya',
  'Goodwood Motor Circuit',
  // Real-World — Asia / Oceania
  'Suzuka Circuit',
  'Fuji International Speedway',
  'Tsukuba Circuit',
  'Autopolis',
  'Mount Panorama (Bathurst)',
  'Kyoto Driving Park',
  // Original GT Tracks
  'Alsace',
  'Autodrome Lago Maggiore',
  'Blue Moon Bay Speedway',
  'Broad Bean Raceway',
  'Circuit de Sainte-Croix',
  'Deep Forest Raceway',
  'Dragon Trail',
  'Eiger Nordwand',
  'Grand Valley Highway 1',
  'High Speed Ring',
  'Northern Isle Speedway',
  'Sardegna Road Track',
  'Sardegna Windmills (Dirt)',
  'Special Stage Route X',
  'Tokyo Expressway',
  'Trial Mountain',
];

export const MK8_TRACKS = [
  // Mushroom Cup
  'Mario Kart Stadium',
  'Water Park',
  'Sweet Sweet Canyon',
  'Thwomp Ruins',
  // Flower Cup
  'Mario Circuit',
  'Toad Harbor',
  'Twisted Mansion',
  'Shy Guy Falls',
  // Star Cup
  'Sunshine Airport',
  'Dolphin Shoals',
  'Electrodrome',
  'Mount Wario',
  // Special Cup
  'Cloudtop Cruise',
  'Bone-Dry Dunes',
  "Bowser's Castle",
  'Rainbow Road',
  // Shell Cup
  'Moo Moo Meadows',
  'Mario Circuit (GBA)',
  'Cheep Cheep Beach',
  "Toad's Turnpike",
  // Banana Cup
  'Dry Dry Desert',
  'Donut Plains 3',
  'Royal Raceway',
  'DK Jungle',
  // Leaf Cup
  'Wario Stadium (DS)',
  'Sherbet Land',
  'Music Park',
  'Yoshi Valley',
  // Lightning Cup
  'Tick-Tock Clock',
  'Piranha Plant Slide',
  'Grumble Volcano',
  'Rainbow Road (N64)',
  // Golden Dash Cup
  'Paris Promenade',
  'Toad Circuit',
  'Choco Mountain',
  'Coconut Mall',
  // Lucky Cat Cup
  'Tokyo Blur',
  'Shroom Ridge',
  'Sky Garden',
  'Ninja Hideaway',
  // Turnip Cup
  'New York Minute',
  'Mario Circuit 3',
  'Kalimari Desert',
  'Waluigi Pinball',
  // Propeller Cup
  'Sydney Sprint',
  'Snow Land',
  'Mushroom Gorge',
  'Sky-High Sundae',
  // Rock Cup
  'London Loop',
  'Boo Lake',
  'Rock Rock Mountain',
  'Maple Treeway',
  // Moon Cup
  'Berlin Byways',
  'Peach Gardens',
  'Merry Mountain',
  'Rainbow Road (3DS)',
  // Fruit Cup
  'Amsterdam Drift',
  'Riverside Park',
  'DK Summit',
  "Yoshi's Island",
  // Boomerang Cup
  'Bangkok Rush',
  'Mario Circuit (DS)',
  'Waluigi Stadium',
  'Singapore Speedway',
  // Feather Cup
  'Athens Dash',
  'Daisy Cruiser',
  'Moonview Highway',
  'Squeaky Clean Sprint',
  // Cherry Cup
  'Los Angeles Laps',
  'Sunset Wilds',
  'Koopa Cape',
  'Vancouver Velocity',
  // Acorn Cup
  'Rome Avanti',
  'DK Mountain',
  'Daisy Circuit',
  'Piranha Plant Cove',
  // Spiny Cup
  'Madrid Drive',
  "Rosalina's Ice World",
  'Bowser Castle 3',
  'Rainbow Road (Wii)',
];

/** Get track list by title ID */
export function getTracksByTitle(titleId) {
  switch (titleId) {
    case 'f1': return F1_TRACKS;
    case 'granTurismo7': return GT7_TRACKS;
    case 'marioKart': return MK8_TRACKS;
    default: return [];
  }
}

/** Race variables/settings per game */
export const RACE_VARIABLES = {
  f1: [
    { id: 'tireWear', label: 'Tire Wear' },
    { id: 'fuelConsumption', label: 'Fuel Consumption' },
    { id: 'damage', label: 'Damage' },
    { id: 'drs', label: 'DRS Enabled' },
    { id: 'safetyCarEnabled', label: 'Safety Car' },
    { id: 'penalties', label: 'Penalties' },
    { id: 'parc_ferme', label: 'Parc Fermé' },
  ],
  granTurismo7: [
    { id: 'tireWear', label: 'Tire Wear' },
    { id: 'fuelConsumption', label: 'Fuel Consumption' },
    { id: 'damage', label: 'Damage' },
    { id: 'pitStops', label: 'Pit Stops' },
    { id: 'slipstream', label: 'Slipstream' },
    { id: 'boP', label: 'Balance of Performance (BoP)' },
    { id: 'tuning', label: 'Tuning Allowed' },
    { id: 'abs', label: 'ABS Allowed' },
    { id: 'tractionControl', label: 'Traction Control Allowed' },
  ],
  marioKart: [
    { id: 'items', label: 'Items Enabled' },
    { id: 'coins', label: 'Coins Enabled' },
    { id: 'smartSteering', label: 'Smart Steering Allowed' },
    { id: 'autoAccelerate', label: 'Auto-Accelerate Allowed' },
    { id: 'cc150', label: '150cc' },
    { id: 'cc200', label: '200cc' },
    { id: 'mirror', label: 'Mirror Mode' },
  ],
};

/** Get race variables for a title */
export function getVariablesByTitle(titleId) {
  return RACE_VARIABLES[titleId] || [];
}

/** Lap count options: 1–20 */
export const LAP_OPTIONS = Array.from({ length: 20 }, (_, i) => i + 1);

/* Gran Turismo 7 car classes a round can be raced in (owner, 31 Oct).
   Saved on the event as `carClass` (the label itself); blank = not set. */
export const CAR_CLASSES = ['Gr.1', 'Gr.2', 'Gr.3', 'Gr.4', 'Gr.X', 'Road cars'];

/* Gran Turismo 7 tyres a round can be raced on (owner, 1 Nov).
   Saved on the event as `tyre` (the label itself); blank = not set. */
export const TYRES = ['Racing Hard', 'Racing Medium', 'Racing Soft'];
